$('.accordion').find('dt').on('click', function () {
  $(this).next().stop().slideToggle();
  $(this).toggleClass('is_active');
});
$('.grad-btn').on('click', function () {
  $(this).prev().toggleClass('open');
  $(this).toggleClass('open');
})
